

import { mapActions, mapGetters } from 'vuex'
import Detail from '../components/customer/Detail'
import PasswordChange from '../components/customer/PasswordChange'
import auth from '../../common/mixins/auth'
import alertWeb from '../../common/mixins/alertWeb'
import redirectWeb from '../../common/mixins/redirectWeb'
import unauthenticated from '@/../common/mixins/unauthenticated'
import OrderHistory from '@/../common/components/OrderHistory'
import currentUser from '@/middleware/currentUser'

export default {
  name: 'Profile',
  components: {
    Detail,
    PasswordChange,
    OrderHistory
  },
  mixins: [auth, alertWeb, redirectWeb, unauthenticated],
  middleware: currentUser,
  data () {
    return {
      modalShow: false,
      tab: this.$route.query.tab ? parseInt(this.$route.query.tab) : 1,
      loading: false
    }
  },
  head () {
    return {
      title: this.$getPageTitle('Profile' + (this.tab === 1 ? ' - Detail' : this.tab === 2 ? ' - Password Change' : this.tab === 6 ? ' - Recent Orders' : ''))
    }
  },
  computed: {
    ...mapGetters(['currentUser'])
  },
  watch: {
    '$route.query.tab' (newValue) {
      this.tab = parseInt(newValue)
    }
  },
  methods: {
    ...mapActions(['requestDelete', 'logout']),
    deleteAccount () {
      this.loading = true
      this.requestDelete().then((data) => {
        this.$root.$bvToast.toast(data.message, {
          title: data.status,
          variant: data.status === 'Success' ? 'success' : 'danger',
          solid: true
        })
        return this.$router.push({ name: 'auth' })
      })
    }
  }
}
